import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("hc_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function saveAuth(token, user) {
  localStorage.setItem("hc_token", token);
  localStorage.setItem("hc_user", JSON.stringify(user));
}
export function clearAuth() {
  localStorage.removeItem("hc_token");
  localStorage.removeItem("hc_user");
}
export function getStoredUser() {
  try { return JSON.parse(localStorage.getItem("hc_user")); } catch { return null; }
}
